import React from 'react';

const Footer = () => (
  <footer className="bg-faded">
    <div className="container py-5">
      <p>
        A project of the{' '}
        <a href="http://keaconservation.co.nz" rel="noopener noreferrer" target="_blank">
          Kea Conservation Trust
        </a>
        . Development by{' '}
        <a href="https://electricmagnetic.net" rel="noopener noreferrer" target="_blank">
          ElectricMagnetic
        </a>
        .
      </p>
      <p>
        Supported by the{' '}
        <a href="http://www.apwt.org.nz" rel="noopener noreferrer" target="_blank">
          Arthur's Pass Wildlife Trust
        </a>{' '}
        and the{' '}
        <a href="http://doc.govt.nz" rel="noopener noreferrer" target="_blank">
          Department of Conservation
        </a>
      </p>
    </div>
  </footer>
);

export default Footer;
